export default {
  middleware_url: "https://charbonneau.fluid-it.fr",
  cake_url: "https://charbonneau.cake.fluid-it.fr",
  pwa_url: "https://app.charbonneau.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  billingConforamaEnabled: false,
  showLockBillingButton: true,
  useRatingSystem: true,
  useMapPage: true,
  useGpsTracking: true,
  instancePrefix: "35",
  googleMap: {
    api: "AIzaSyA_Dm4jv9tf_Hj6bw_vKhx0XQ_r4HyODRo",
  },
  // Instance québécoise : autocomplete Google restreint au Canada par défaut
  address: {
    defaultCountry: "CA",
    countries: ["CA", "OTHER"],
  },
};
